import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const CP_API = `${BACKEND_URL}/api`;

// Separate axios instance for the Client Portal.
// Cookie-based auth (`client_portal_token`) is sent automatically via `withCredentials`.
const cpApi = axios.create({
  baseURL: CP_API,
  withCredentials: true,
});

// Also support Bearer token fallback for environments where cross-site cookies are blocked.
cpApi.interceptors.request.use((config) => {
  const t = localStorage.getItem("cp_token");
  if (t && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

export default cpApi;
